import Entity from '../../../../core/domain/entity';
import UniqueEntityID from '../../../../core/domain/unique_entity_id';
import { DietitianId } from '../../../dietitian/domain/dietitian';
import { SharedDocumentId } from '../../../document/domain/shared_document/shared_document';
import { PatientId } from '../../../patient/domain/patient';

export interface CompositionProps {
  dietitianId: DietitianId;
  patientId: PatientId;
  name: string;
  content?: string;
  createdAt?: Date;
  updatedAt?: Date;
  sharedDocumentId?: SharedDocumentId | undefined;
  sharedAt?: Date | undefined;
}

export class CompositionId extends Entity<unknown> {
  private constructor(id?: UniqueEntityID) {
    super(null, id);
  }

  public static create(id?: UniqueEntityID): CompositionId {
    return new CompositionId(id);
  }
}

export class Composition extends Entity<CompositionProps> {
  get compositionId(): CompositionId {
    return CompositionId.create(this.id);
  }

  get dietitianId(): DietitianId {
    return this.props.dietitianId;
  }

  get patientId(): PatientId {
    return this.props.patientId;
  }

  get name(): string {
    return this.props.name;
  }

  set name(value: string) {
    this.props.name = value;
  }

  get createdAt(): Date | undefined {
    return this.props.createdAt;
  }

  get updatedAt(): Date | undefined {
    return this.props.updatedAt;
  }

  get content(): string | undefined {
    return this.props.content;
  }

  get sharedDocumentId(): SharedDocumentId | undefined {
    return this.props.sharedDocumentId;
  }

  set sharedDocumentId(value: SharedDocumentId | undefined) {
    this.props.sharedDocumentId = value;
  }

  get sharedAt(): Date | undefined {
    return this.props.sharedAt;
  }

  set sharedAt(value: Date | undefined) {
    this.props.sharedAt = value;
  }

  private constructor(props: CompositionProps, id?: UniqueEntityID) {
    super(props, id);
  }

  copyWith(props: CompositionProps): Composition {
    return Composition.create(
      {
        ...this.props,
        ...props,
      },
      this.id,
    );
  }

  public static create(
    props: CompositionProps,
    id?: UniqueEntityID,
  ): Composition {
    return new Composition(props, id);
  }
}
